import React, { useState, useEffect } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { WebSocketProvider } from './context/WebSocketContext';
import { SystemEventProvider } from './context/SystemEventContext';
import { ProcessProvider } from './context/ProcessContext';
import { LogProvider } from './context/LogContext';
import Login from './components/Login';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import './App.css';
import Dashboard from './components/Dashboard';
import CreateAlertPage from './pages/CreateAlertPage'; // New Page
import ManageAlertsPage from './pages/ManageAlertsPage'; // New Page
import ThemeDropdown from './components/ThemeDropdown';
import Header from './components/Header';
import ModalContainer from './components/ModalContainer/ModalContainer';
import ModalTest from './components/ModalTest';



import { AlertProvider } from './contexts/AlertContext';
import BackgroundProcessingService from './services/BackgroundProcessingService';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    window.location.href = '/login';
    return null;
  }
  return children;
}

function AppHeader() {
  const { userData } = useAuth();
  
  return (
    <header className="App-header">
      <div className="app-title">
        <span>DeepR Dashboard</span>
      </div>
      <div className="header-right">
        {userData && userData.user_name ? (
          <span className="username">{userData.user_name}</span>
        ) : (
          <span className="username">User</span>
        )}
        <ThemeDropdown />
      </div>
    </header>
  );
}

function MainLayout() {

  return (
    <div className="App">
      <div className="App-main-container">
        <Header />

        
        <main className="App-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/create-alert" element={<AlertProvider><CreateAlertPage /></AlertProvider>} />
            <Route path="/manage-alerts" element={<AlertProvider><ManageAlertsPage /></AlertProvider>} />
            <Route path="/modal-test" element={<ModalTest />} />
            <Route path="*" element={<Dashboard />} /> {/* Default or fallback route */}
          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  // Initialize background processing service
  useEffect(() => {
    // Start the background processing service to handle server events
    // even when navigating between pages
    BackgroundProcessingService.initialize();
    
    // Clean up on unmount
    return () => {
      BackgroundProcessingService.cleanup();
    };
  }, []);
  
  return (
    <AuthProvider>
      <ThemeProvider>
        <ProcessProvider> 
          <SystemEventProvider> 
            <LogProvider>
              <WebSocketProvider> 
                <Router basename="">
                  <CssBaseline />
                  {/* ModalContainer ensures modals always appear on top */}
                  <ModalContainer />
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/*"
                      element={
                        <PrivateRoute>
                          <MainLayout />
                        </PrivateRoute>
                      }
                    />
                  </Routes>
                </Router>
              </WebSocketProvider>
            </LogProvider>
          </SystemEventProvider>
        </ProcessProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
